import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

export const fromTaxToDto = (tax) => ({
  name: fromAnyToString(tax.name),
  percentage: fromAnyToString(tax.percentage),
  applied_to: fromAnyToString(tax.appliedTo),
  is_default: fromAnyToBool(tax.isDefault),
});
